// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"943":"0b6de686","945":"0b6de686"}[chunkId] + ".chunk.css";
};